// src/components/home/theme.ts
export const colors = {
  coreBlue: '#162537',
  coreBlueDark: '#133E5A',
  baselineBlue: '#E6F7FB',
  baselineWhite: '#FFFFFF',
  signalBlue: '#71E3FF',
  performGreen: '#64FF98',
  markCyan400: '#0096BA',
  markCyan200: '#00D1F3',
  patternBlue1: '#71E3FF',
  patternBlue2: '#00D1F3',
  patternBlue3: '#0096BA',
  patternBlue4: '#133E5A',
  patternGreen1: '#64FF98',
  patternGreen2: '#3FCB74',
  patternGreen3: '#2C8A55',
  patternGreen4: '#214945',

  textSecondary: '#4B5B6B',
  textMuted: '#5F6E7C',
  textInverseSecondary: '#A8C4D6',
  textMutedDarkBg: '#93A9BA',

  borderSubtle: '#DCE6EC',
  borderDefault: '#C2D2DC',
  borderAccentLight: '#B8E9F7',
  borderInverse: 'rgba(255, 255, 255, 0.18)',
  borderInverseSubtle: 'rgba(255, 255, 255, 0.10)',

  actionAccentBg: '#71E3FF',
  actionAccentFg: '#162537',
  actionAccentBgHover: '#4FD8F9',
  actionPrimaryBg: '#162537',
  actionPrimaryFg: '#FFFFFF',
  actionPrimaryBgHover: '#0E1A28',

  footerMuted: '#7B93A6',
} as const;

export const fonts = {
  sans: `"Geist", ui-sans-serif, -apple-system, "Helvetica Neue", Arial, sans-serif`,
  mono: `"Geist Mono", ui-monospace, "SF Mono", Menlo, monospace`,
} as const;

export const layout = {
  maxWidth: '1180px',
} as const;

export const radii = {
  sm: '4px',
} as const;
